import { MerchantHeader } from '@reveni-io/reveni-ui'

const PortalMerchantHeader = ({ merchantInfo, descriptionText, insideCard = false }) => {
  if (!insideCard) {
    return (
      <MerchantHeader
        logoUrl={merchantInfo?.theme?.logo_url}
        storeName={merchantInfo?.name}
        storeUrl={merchantInfo?.domain}
        descriptionText={descriptionText}
      />
    )
  }

  return (
    <MerchantHeader
      coverUrl={merchantInfo?.theme?.returns_cover_url}
      logoUrl={merchantInfo?.theme?.logo_url}
      storeName={merchantInfo?.name}
      storeUrl={merchantInfo?.domain}
      descriptionText={descriptionText}
      addHisOwnContainerStyles={false}
      orientation="column"
    />
  )
}

export default PortalMerchantHeader
